import StatusSection from "@/v2-status-client/status/section/StatusSection"
import StatusPlatformGroupSkeleton from "@/v2-status-client/status/skeleton/StatusPlatformGroupSkeleton"

// Services-section skeleton. Three platform cards with staggered
// row counts so the placeholder reads as a real overview rather
// than a regular grid of clones. Wrapped in `StatusSection` so it
// shares the section heading + aside copy with the live render
// path -- on a slow first load the customer reads "Services /
// Status of every application Placepoint operates or monitors"
// up top and watches the cards fill in underneath.
function StatusServicesSkeleton() {
  return (
    <StatusSection
      title="Services"
      aside="Status of every application Placepoint operates or monitors"
      aria-busy="true"
    >
      <div className="flex flex-col gap-6">
        {PLATFORM_PLACEHOLDERS.map((p, i) => (
          <StatusPlatformGroupSkeleton
            key={i}
            rowCount={p.rowCount}
            headerTitleWidth={p.headerWidth}
          />
        ))}
      </div>
    </StatusSection>
  )
}

// Hand-tuned placeholders so the section reads as a real list of
// platforms. Counts roughly mirror today's live data without
// importing the actual platform list (which would couple the
// skeleton to runtime state we don't have yet).
const PLATFORM_PLACEHOLDERS = [
  { headerWidth: "w-40", rowCount: 5 },
  { headerWidth: "w-32", rowCount: 1 },
  { headerWidth: "w-28", rowCount: 2 },
  { headerWidth: "w-36", rowCount: 3 },
] as const

export default StatusServicesSkeleton
